import { IFeatureFlagsBatch } from "types/config";
import Fetch from "utils/fetch";

export const getFeatureFlags = (body: IFeatureFlagsBatch) => 
  Fetch.post("config/feature-flags/batch", body).then(({ data }) => data);